import "core-js/modules/es.array.fill.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_2 = {
  "clip-path": "url(#clip0_390_400)"
};
var _hoisted_3 = ["fill"];
var _hoisted_4 = ["fill"];
var _hoisted_5 = ["fill"];

var _hoisted_6 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_390_400"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "17.98",
  height: "25",
  fill: "white",
  transform: "translate(13 9)"
})])], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M30.73 22L26.79 25.5C26.6841 25.5891 26.5552 25.6462 26.4181 25.6648C26.281 25.6834 26.1415 25.6627 26.0158 25.6051C25.89 25.5474 25.7832 25.4553 25.7078 25.3393C25.6325 25.2233 25.5916 25.0883 25.59 24.95V18C25.5909 17.861 25.6327 17.7254 25.71 17.61C25.7852 17.4983 25.8887 17.4085 26.01 17.35C26.138 17.2908 26.2804 17.27 26.42 17.29C26.5562 17.3129 26.6839 17.3716 26.79 17.46L30.73 21C30.8091 21.0661 30.8738 21.1478 30.92 21.24C30.9596 21.335 30.98 21.437 30.98 21.54C30.98 21.643 30.9596 21.7449 30.92 21.84C30.8711 21.9305 30.8068 22.0117 30.73 22.08V22Z",
    fill: $props.fill
  }, null, 8, _hoisted_3), _createElementVNode("path", {
    d: "M13.25 21L17.19 17.5C17.2958 17.4109 17.4248 17.3537 17.5619 17.3351C17.6989 17.3165 17.8385 17.3372 17.9642 17.3949C18.09 17.4525 18.1967 17.5447 18.2721 17.6607C18.3475 17.7766 18.3884 17.9116 18.39 18.05V25C18.389 25.1389 18.3473 25.2745 18.27 25.39C18.1948 25.5017 18.0913 25.5914 17.97 25.65C17.842 25.7091 17.6996 25.73 17.56 25.71C17.4238 25.6871 17.2961 25.6284 17.19 25.54L13.25 22C13.1708 21.9339 13.1062 21.8522 13.06 21.76C13.0204 21.6649 13 21.5629 13 21.46C13 21.357 13.0204 21.255 13.06 21.16C13.1154 21.0979 13.1794 21.044 13.25 21Z",
    fill: $props.fill
  }, null, 8, _hoisted_4), _createElementVNode("path", {
    d: "M21.83 34C21.6179 34 21.4144 33.9157 21.2643 33.7657C21.1143 33.6157 21.03 33.4122 21.03 33.2V9.8C21.03 9.58783 21.1143 9.38434 21.2643 9.23431C21.4144 9.08429 21.6179 9 21.83 9C22.0422 9 22.2457 9.08429 22.3957 9.23431C22.5457 9.38434 22.63 9.58783 22.63 9.8V33.2C22.63 33.4122 22.5457 33.6157 22.3957 33.7657C22.2457 33.9157 22.0422 34 21.83 34Z",
    fill: $props.fill
  }, null, 8, _hoisted_5)]), _hoisted_6]);
}